/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_TitleInputs */

const en_vc_mcp_title = /** @type {(inputs: Vc_Mcp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for AI agents from day one`)
};

const zh_vc_mcp_title = /** @type {(inputs: Vc_Mcp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从第一天起就为 AI 助手而生`)
};

/**
* | output |
* | --- |
* | "Built for AI agents from day one" |
*
* @param {Vc_Mcp_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_title = /** @type {((inputs?: Vc_Mcp_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_title(inputs)
	return zh_vc_mcp_title(inputs)
});
export { vc_mcp_title as "vc.mcp.title" }